import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LinkedEducatorContext } from 'src/shared/linked-educator-icon/linked-educator-icon.component';

@Component({
  selector: 'cert-linked-educator-header-modal',
  templateUrl: './linked-educator-header-modal.component.html',
  styles: ``,
  standalone: false,
})
export class LinkedEducatorHeaderModalComponent {
  linkedEducatorContext!: LinkedEducatorContext;

  constructor(private readonly activeModal: NgbActiveModal) {}

  onClose() {
    this.activeModal.close();
  }
}
